import Const from 'constants';

const SearchRuleBuilder = {
    like(propName, likeValue) {
        if (likeValue.length > 0) {
            return {
                [propName]: {
                    filterType: Const.FILTER_TYPE_LIKE,
                    filterValue: likeValue,
                },
            };
        }
        return {};
    },

    inArr(propName, arr, callback) {
        return {
            [propName]: {
                filterType: Const.FILTER_TYPE_IN_ARRAY,
                filterValue: arr,
                dataItemCallback: callback,
            },
        };
    },

    notInArr(propName, arr, callback) {
        return {
            [propName]: {
                filterType: Const.FILTER_TYPE_NOT_IN_ARRAY,
                filterValue: arr,
                addConditionCallback: callback,
            },
        };
    },

    hasVal(propName, arr) {
        return {
            [propName]: {
                filterType: Const.FILTER_TYPE_ARRAY_HAS_VALUE,
                filterValue: arr,
            },
        };
    },

    arrHasDuplicates(propName, arr) {
        return {
            [propName]: {
                filterType: Const.FILTER_TYPE_ARRAY_HAS_DUPLICATES,
                filterValue: arr,
            },
        };
    },

    arrHasNoDuplicates(propName, arr, callback) {
        return {
            [propName]: {
                filterType: Const.FILTER_TYPE_ARRAY_HAS_NO_DUPLICATES,
                filterValue: arr,
                dataItemCallback: callback,
            },
        };
    },

    equal(propName, equalValue, callback) {
        return {
            [propName]: {
                filterType: Const.FILTER_TYPE_EQUAL,
                filterValue: equalValue,
                dataItemCallback: callback,
            },
        };
    },

    callback(propName, callback) {
        return {
            [propName]: {
                filterType: Const.FILTER_TYPE_CALLBACK,
                callback,
            },
        };
    },
};

export {SearchRuleBuilder};
